import type { Enums } from "../types";

export function getAbsenceStateColor(state: Enums<"absenceState">): Enums<"color"> {
	switch (state) {
		case "pending":
			return "amber";
		case "approved":
			return "emerald";
		case "rejected":
			return "red";
		case "cancelled":
			return "red";
		default:
			return "gray";
	}
}
